var _defs, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstragramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram_2_",
    "data-name": "instagram (2)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.06,
    height: 58.06,
    viewBox: "0 0 58.06 58.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.823,
    y1: 0.049,
    x2: 0.119,
    y2: 0.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f4bad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f78e47"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M39.916,0H18.144A18.144,18.144,0,0,0,0,18.144V39.916A18.144,18.144,0,0,0,18.144,58.059H39.916A18.144,18.144,0,0,0,58.059,39.916V18.144A18.144,18.144,0,0,0,39.916,0Zm12.7,39.916a12.714,12.714,0,0,1-12.7,12.7H18.144a12.714,12.714,0,0,1-12.7-12.7V18.144a12.714,12.714,0,0,1,12.7-12.7H39.916a12.714,12.714,0,0,1,12.7,12.7Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4756",
    "data-name": "Path 4756",
    d: "M18.515,4A14.515,14.515,0,1,0,33.03,18.515,14.515,14.515,0,0,0,18.515,4Zm0,23.587a9.072,9.072,0,1,1,9.072-9.072A9.083,9.083,0,0,1,18.515,27.587Z",
    transform: "translate(10.515 10.515)",
    fill: "url(#linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_402",
    "data-name": "Ellipse 402",
    cx: 1.934,
    cy: 1.934,
    r: 1.934,
    transform: "translate(42.699 11.492)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstragramIcon);
export default __webpack_public_path__ + "static/media/instragramIcon.193c8d43e344a4bc8f7eadc14045fe8e.svg";
export { ForwardRef as ReactComponent };